import React, { useState } from "react";
import BottomNav from "./BottomNav";
import GoTo from "./GoTo";
const ToTop = (props) => {
  const { name } = props;

  const [visible, setvisible] = useState(false);
  const [iconopen, seticonOpen] = useState(false);
  const iconView = () => {
    seticonOpen(!iconopen);
  };
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setvisible(true);
    } else if (scrolled <= 300) {
      setvisible(false);
    }
  };
  window.addEventListener("scroll", toggleVisible);
  return (
    <>
      <BottomNav iconopen={iconopen} iconView={iconView} />
      <GoTo visible={visible} name={name} />
    </>
  );
};

export default ToTop;
